import { useQuery } from '@tanstack/react-query';
import { financialApi } from '../api/financialApi';

export const useResidentFinancialDetails = (residentId: string) => {
  return useQuery({
    queryKey: ['resident-financial-details', residentId],
    queryFn: () => financialApi.getResidentFinancialDetails(residentId),
    enabled: !!residentId,
  });
};
